module.exports = __webpack_public_path__ + "img/chevron_down.dbf23a6e.svg";